<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="9.6" cy="9.6" r="9.6" fill="#0A66C2" />
    <path
      d="M12.8121 11.521V13.9488C12.8121 14.5761 13.3207 15.0847 13.9481 15.0847C14.5753 15.0847 15.0839 14.5763 15.084 13.949L15.0847 11.0645C15.0847 9.0909 14.6602 7.57384 12.3578 7.57384C11.4814 7.54125 10.6578 7.99217 10.2118 8.748C10.2083 8.75393 10.2019 8.75762 10.195 8.75762C10.1843 8.75762 10.1757 8.74894 10.1757 8.73823V8.25687C10.1757 7.98032 9.95146 7.75612 9.67491 7.75612H9.08528C8.48308 7.75612 7.9949 8.2443 7.9949 8.8465V13.9487C7.9949 14.576 8.50342 15.0845 9.13071 15.0845C9.758 15.0845 10.2665 14.576 10.2665 13.9487V11.4592C10.2665 10.5032 10.4475 9.57731 11.6307 9.57731C12.797 9.57731 12.8121 10.6712 12.8121 11.521Z"
      fill="white"
    />
    <path
      d="M4.11328 5.43407C4.11341 6.16339 4.70372 6.75452 5.43176 6.75439C5.78139 6.75433 6.11666 6.61514 6.36384 6.36744C6.61101 6.11974 6.74984 5.78383 6.74977 5.4336C6.74964 4.70428 6.15934 4.11315 5.43129 4.11328C4.70324 4.11341 4.11315 4.70475 4.11328 5.43407Z"
      fill="white"
    />
    <path
      d="M4.29359 8.89311V13.9477C4.29359 14.5757 4.80264 15.0847 5.43058 15.0847C6.05852 15.0847 6.56757 14.5757 6.56757 13.9477V8.89311C6.56757 8.26517 6.05852 7.75612 5.43058 7.75612C4.80264 7.75612 4.29359 8.26517 4.29359 8.89311Z"
      fill="white"
    />
  </svg>
</template>

<script>
export default {
  name: 'Linkedin',
};
</script>
